import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { delayWhen, finalize } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../environments/environment';
import { AppLoadingSpinnerComponent } from '../components/loading-spinner/loading-spinner.component';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private dialog: MatDialog) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let loadingDialogRef: MatDialogRef<AppLoadingSpinnerComponent, unknown> | null = null;

    if (req.url.indexOf(environment.poolApi) !== -1) {
      if (
        req.url.indexOf(`${environment.poolApi}/accounts`) !== -1 &&
        req.url.indexOf(`${environment.poolApi}/accounts/statistics`) === -1 &&
        req.url.indexOf(`${environment.poolApi}/access-token/workers`) === -1 &&
        req.url.indexOf(`${environment.poolApi}/access-token/income`) === -1
      ) {
        loadingDialogRef = this.dialog.open(AppLoadingSpinnerComponent, {
          panelClass: 'wm-spinner',
          disableClose: true,
        });
      }
      const startTime = new Date().getTime();

      return next.handle(req).pipe(
        delayWhen(() => {
          // set 1s as minimum response time
          const elapsedTime = new Date().getTime() - startTime;
          const delay = Math.max(0, 1000 - elapsedTime);
          return timer(delay);
        }),
        finalize(() => {
          if (loadingDialogRef) {
            loadingDialogRef.close();
            loadingDialogRef = null;
          }
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
